/** Amounts from the API are paise integers — format in the UI only. */
export const formatCurrency = (paise: number): string => {
  return `₹${((Number(paise) || 0) / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

/** Alias used across admin pages */
export const formatMoney = formatCurrency;

export const toIsoDate = (dateStr: string | Date | null | undefined): string => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString();
};

export const formatDate = (dateStr: string | Date): string => {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateTime = (dateStr: string | Date): string => {
  const d = new Date(dateStr);
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const formatDuration = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}m ${s}s`;
};

export const truncate = (str: string, len = 50): string =>
  str?.length > len ? str.slice(0, len) + '…' : str;

export const getStatusBadgeClass = (status: string): string => {
  const map: Record<string, string> = {
    active: 'badge-green', approved: 'badge-green', online: 'badge-green', paid: 'badge-green', delivered: 'badge-green', completed: 'badge-green',
    pending: 'badge-yellow', waiting: 'badge-yellow', processing: 'badge-yellow', attempted: 'badge-yellow',
    inactive: 'badge-gray', offline: 'badge-gray', cancelled: 'badge-gray', failed: 'badge-red',
    rejected: 'badge-red', suspended: 'badge-red', blocked: 'badge-red',
    busy: 'badge-orange',
    shipped: 'badge-blue', confirmed: 'badge-blue',
  };
  return map[status?.toLowerCase()] || 'badge-gray';
};
